module.exports = __webpack_public_path__ + "static/media/archisha_shukla.4681ec5b.png";